//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
import "../Features/Features.AECDesign.RoomAttributeListBuilder.js";
import "../Features/Features.AECDesign.RoomFaceListItemBuilderList.js";
import "../GeometricUtilities/GeometricUtilities.ProjectionOptions.js";
import "../no/Features.js";
import "../no/GeometricUtilities.js";
import "../no/ObjectList.js";
let d=[[[0,"Associativity",1,0],[1,"AttributeList",0,"Features.AECDesign.RoomAttributeListBuilder",0],[1,"FaceList",0,"Features.AECDesign.RoomFaceListItemBuilderList",0],[1,"ProjectionDirection",0,"GeometricUtilities.ProjectionOptions",0],[0,"RoomColor",1,0],[0,"RoomName",1,0]],[[["bUpdateRoomAreaAndVolume"],"EvaluateAttributes",{},1,0],[[],"UpdateTypeForAttributeListBuilder",{},0,0],[["nBodies","createdRoomBodies"],"GetCreatedRoomBodies",{},0,0],[["roomID"],"UpdateRoomID",{},1,0],[["bUpdateRoomAreaAndVolume"],"ResetAttributes",{},1,0],[[],"CreateRoomFaceListItemBuilder",{R_:{roomFaceListItemBuilder:"Features.AECDesign.RoomFaceListItemBuilder"}},0,0]],[]];
SPLM.Features.AECDesign.RoomBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.RoomBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;